import i18n from "lib/i18n";
import { template } from "lodash";
import LargeTooltipView from "views/large_tooltip_view";
import { track } from "../lib/analytics";
/* eslint-disable
    class-methods-use-this,
    constructor-super,
    func-names,
    no-constant-condition,
    no-eval,
    no-multi-assign,
    no-shadow,
    no-this-before-super,
    no-undef,
    no-underscore-dangle,
    no-unused-expressions,
*/
// TODO: This file was created by bulk-decaffeinate.
// Fix any style issues and re-enable lint.
/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * DS206: Consider reworking classes to avoid initClass
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
let UserNotificationSettingsView;

// UserNotificationSettingsView is being kept to help port
// people over to the new TC.ContentSubscriptionIndicatorView

// it will eventually be deprecated and removed.
//
export default UserNotificationSettingsView = (function () {
  UserNotificationSettingsView = class UserNotificationSettingsView extends LargeTooltipView {
    static initClass() {
      this.prototype.tagName = "form";
      this.prototype.className = "user-notification-settings-view large-tooltip arrow-right";

      this.prototype.template = template(`\
<h4 class="legacy">
  <%= i18n.t('comment.label.notification_settings') %>
</h4>
<fieldset>
  <input type="checkbox" id="notify_when_new_comments" name="notify_when_new_comments">
  <label for="notify_when_new_comments">
    <%= i18n.t('comment.label.notify_me_when_there_are_updates') %>
  </label>
</fieldset>\
`, { imports: { i18n } });
    }

    initialize(options) {
      super.initialize(options);
      this._updateCheckbox = this._updateCheckbox.bind(this);
      this.contentSubscription = options.contentSubscription;

      this.$el.html(this.template());

      // handle checkbox
      this.checkbox = this.$el.find("#notify_when_new_comments");
      this.checkbox.on("click", () => {
        this.contentSubscription.toggle();
        return this._trackAnalytics(this.contentSubscription.get("subscription_type"));
      });

      // handle subscription changes
      this.contentSubscription.on("change", this._updateCheckbox);

      this._updateCheckbox();
      return this.hide();
    }

    _updateCheckbox() {
      return this.checkbox.prop("checked", this.contentSubscription.isSubscribed());
    }

    _trackAnalytics(type) {
      track("ContentSubscription", type, "UserNotificationSettingsView");
    }
  };
  UserNotificationSettingsView.initClass();
  return UserNotificationSettingsView;
}());
